<template>
  <footer>
    <div class="section">
      <HearFromMe
        :bio="data.bio"
        :beforeEnterH1="beforeEnterH1"
        :enterH1="enterH1"
        :beforeEnterBox="beforeEnterBox"
        :enterBox="enterBox"
      />
      <ContactUs :beforeEnter="beforeEnter" :enter="enter" />
      <Feature
        v-if="data.contact_infos"
        :contact="data.contact_infos"
        :beforeEnter="beforeEnter"
        :enter="enter"
      />
      <Copyrights
        v-if="data.sc_medias"
        :medias="data.sc_medias"
        :name="data.name"
        :portfolio="data.portfolio"
        :beforeEnter="beforeEnterBox"
        :enter="enterBox"
      />
    </div>
  </footer>
</template>

<script>
import HearFromMe from "./footer/HearFromMe";
import ContactUs from "./footer/ContactUs";
import Feature from "./footer/Feature";
import Copyrights from "./footer/Copyrights";
import gsapAnimation from "../composables/gsapAnimation";
export default {
  props: { data: Object },
  components: { HearFromMe, ContactUs, Feature, Copyrights },
  setup() {
    const {
      beforeEnterH1,
      enterH1,
      beforeEnter,
      enter,
      beforeEnterBox,
      enterBox,
    } = gsapAnimation({
      h1: "Contact Me",
    });
    return {
      beforeEnterH1,
      enterH1,
      beforeEnter,
      enter,
      beforeEnterBox,
      enterBox,
    };
  },
};
</script>

<style>
footer {
  background: var(--dark);
  color: var(--light);
}

footer input,
footer textarea {
  color: var(--light);
  width: 100%;
  border: none;
  padding: 1rem;
  background: none;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--grey);
}
footer input:focus,
footer textarea:focus {
  outline: none;
  border-bottom-color: var(--primary);
}
footer button {
  width: 100%;
  padding: 1rem;
  background: var(--primary);
  font-weight: 600;
  text-transform: uppercase;
  border: none;
  margin-top: 2rem;
  letter-spacing: 2px;
}
footer .grid {
  margin: 4rem 0;
  text-align: center;
}
footer .grid * {
  margin-bottom: 2rem;
}
footer .grid i.icon {
  font-size: 2rem;
}
footer .grid i.icon:hover {
  color: var(--grey);
}
footer .grid h4 {
  text-transform: uppercase;
  color: var(--primary);
}
footer .grid small {
  color: var(--grey);
}
footer .flex {
  justify-content: space-between;
  align-items: center;
}
footer .flex p {
  margin: 1rem;
}
footer .flex span {
  color: var(--blue);
}
footer ul {
  text-align: center;
}
footer li {
  display: inline-block;
}
footer a i.icon {
  color: var(--light);
  margin-left: 1rem;
  font-size: 1.5rem;
}
</style>
